<template>
  <div class="wheelpage">
    <!-- 商品轮播图共用组件 -->
    <div class="imgWraps">
      <template v-if="!skuImg">
        <img v-show="currentImgType === 'P'" :src="mainImgUrl">
        <video 
          v-show="currentImgType === 'V'" 
          :src="mainImgUrl"
          controls
          autoplay
          muted
        ></video>
      </template>
      <img v-else :src="skuImg" alt="">      
    </div>
    <div class="swiperWrap">
      <div class="iconWrap">
        <i class="el-icon-arrow-left" @click="changLeft()"></i>
      </div>
      <div class="allImg">
        <div 
          v-for="(item,index) in imgUrlList" 
          :key="index" 
          class="ImgItem" 
          :style="imgStyle" 
          @click="changeImg(item, index)"
        >
          <img v-show="item.type === 'P'" :class="index === imgActiveIndex && !skuImg ? 'activeImg' : ''" :src="item.img" class="imgItemsty">
          <div class="videoBox" :class="index === imgActiveIndex && !skuImg ? 'activeImg' : ''" v-show="item.type === 'V'">
            <div class="playIcon">
              <el-icon class="el-icon-caret-right"></el-icon>
            </div>
          </div>
        </div>
      </div>
      <div class="iconWrap">
        <i class="el-icon-arrow-right" @click="changRight()"></i>
      </div>
    </div>

  </div>
</template>
<script>
export default {
  props: {
    imgUrlList: {
      type: Array,
      require: true,
      default: () => {
        return []
      }
    },
    skuImg: {
      type: String,
      require: false,
      default: ''
    }
  },
  data() {
    return {
      currentImgType: 'P',
      mainImgUrl: null,
      imgActiveIndex: 0, // 当前移动图片的索引值
      imgDistance: 0, // 移动的距离
      allDistance: 0 // 总移动距离
    }
  },
  computed: {
    imgStyle() {
      return {
        transform: `translate3d(${this.imgDistance}px, 0, 0)` // 计算移动的距离(x,y,z)
      }
    },
  },
  watch: {
    imgUrlList: {
      handler: function(val, oldVal) {
        if (val.length > 0) {
          this.mainImgUrl = val[0].img
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    removeCurrentSkuImg() {
      this.$emit('removeSkuImg')
    },
    changeImg(item, index) {
      this.removeCurrentSkuImg()
      this.currentImgType = item.type
      this.mainImgUrl = item.img
      this.imgActiveIndex = index
    },
    changLeft() {
      this.removeCurrentSkuImg()
      if (this.imgActiveIndex > 0) {
        this.imgActiveIndex--
        this.imgUrlList.forEach((item, index) => {
          if (this.imgActiveIndex === index) {
            this.mainImgUrl = item.img
            this.currentImgType = item.type
          }
        })
      }
      if (this.imgActiveIndex >= 4) {
        let index = 0
        const temp = window.setInterval(() => { // 利用定时器实现图片左右移动的动画效果
          if (index < 33) { // 移动次数(33次)
            this.imgDistance += 3.5 // 每次向左移动的距离 (移动总距离为33*this.imgDistance)
            index++
            return
          } else {
            window.clearInterval(temp) // 移动完清除定时器
          }
        }, 10)
      }
    },
    changRight() {
      this.removeCurrentSkuImg()
      if (this.imgActiveIndex < this.imgUrlList.length - 1) {
        this.imgActiveIndex++
        this.imgUrlList.forEach((item, index) => {
          if (this.imgActiveIndex === index) {
            this.mainImgUrl = item.img
            this.currentImgType = item.type
          }
        })
        if (this.imgActiveIndex >= 5) {
          this.allDistance = -66 * (this.imgActiveIndex - 4)
          let index = 0
          const temp = window.setInterval(() => {
            if (index < 33) {
              this.imgDistance -= 3.5 // 每次向右移动的距离
              index++
              return
            } else {
              window.clearInterval(temp)
            }
          }, 10)
        }
      } else if (this.imgActiveIndex === this.imgUrlList.length - 1) { // 到达最后一张图片，再点击跳转回第一张
        return
        this.imgActiveIndex = 0
        this.mainImgUrl = this.imgUrlList[0].img
        let index = 0
        const temp = window.setInterval(() => { // 利用定时器实现图片左右移动的动画效果
          if (index < Math.abs(this.allDistance / 2)) { // 取绝对值再除
            this.imgDistance += 2 // 每次向左移动的距离 (移动总距离为33*this.imgDistance)
            index++
            return
          } else {
            window.clearInterval(temp) // 移动完清除定时器
          }
        }, 1)
      }
    }
  }
}
</script>
<style scoped lang="scss">
.wheelpage{
  .imgWraps{
    width: 560px;
    height: 558px;
    img{
      width:100%;
      height: 100%;
    }
    video {
      width: 100%;
      height: 100%;
      background: #f4f4f4;
    }
  }
  .swiperWrap{
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 19px;
    margin-top: 10px;
  }
  .allImg{
    position: relative;
    display: flex;
    gap: 16px;
    overflow: hidden;
    list-style: none;
  }
  .iconWrap{
    width: 24px;
    height: 24px;
    background: rgba(255,255,255,0.6);
    border-radius: 50%;
    text-align: center;
    line-height: 24px;
    cursor: pointer;
  }
  .el-icon-arrow-left{
    margin-top: 2px;
    display: inline-block;
    font-size: 20px;
    color:#292C3A;
  }
  .el-icon-arrow-right{
    margin-top: 2px;
    display: inline-block;
    font-size: 20px;
    color:#292C3A;
  }
  .ImgItem{
    float:left;
    margin: 0 3px;
    cursor: pointer;
    width: 80px;
    height: 80px;
    .videoBox {
      width: 100%;
      height: 100%;
      background: #f4f4f4;
      .playIcon {
        width: 100%;
        height: 100%;
        border-radius: 50%;
        background: #999999;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 80px;
        transform: scale(0.5);
      }
    }
  }
  .imgItemsty{
    width:80px;
    height: 80px;
    border-radius: 2px 2px 2px 2px;
  }
  .activeImg{
    box-sizing: border-box;
    border: 2px solid #EB6643;
  }
}

</style>
